STYLE_ID = 'scrollbar-module-css';
SCROLLBAR_WIDTH_VAR = '--scrollbar-width';

class Scrollbar {
    constructor() {
        this._body = document.body;
        this._run();
    }
    _run = () => {
        this._setCssVariables();
    };
    _getScrollBarWidth = (element) => {
        return parseFloat(getComputedStyle(element).paddingRight) + (window.innerWidth - element.scrollWidth);
    };
    _setCssVariables() {
        // Remove the variables if they already exist.
        let stylesheetElement = document.querySelector(`style#${STYLE_ID}`);
        if (stylesheetElement) {
            stylesheetElement.remove();
        }

        // Set CSS variables
        let stylesheet = document.createElement('style');
        document.head.appendChild(stylesheet);

        stylesheet.setAttribute('id', STYLE_ID);

        let cssRules = `
        :root{`;

        cssRules += `
            ${SCROLLBAR_WIDTH_VAR}:${this._getScrollBarWidth(this._body)}px;`;

        cssRules += `
        }
        `;
        stylesheet.innerHTML = cssRules;
    }
}
//const scrollbar = new Scrollbar();
